'use strict';

const TOKEN_KEY = 'labcodeStudentJwt';
const STUDENT_KEY = 'labcodeStudentProfile';
const CLOUD_PROJECT_KEY = 'labcodeCloudProjectId';
/** @type {readonly [string, string]} */
const STAFF_KEYS = ['labcodeStaffJwt', 'labcodeStaffProfile'];

function getStorage () {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage;
}

function clearStaffKeys (st) {
    if (!st) return;
    try {
        for (const k of STAFF_KEYS) {
            st.removeItem(k);
        }
    } catch (e) {
        // ignore
    }
}

/**
 * UUID do projeto na API Labcode (atualizar em vez de criar novo).
 * @returns {string|null}
 */
export function getLabcodeCloudProjectId () {
    const st = getStorage();
    if (!st) return null;
    try {
        const v = st.getItem(CLOUD_PROJECT_KEY);
        return v && v.length ? v : null;
    } catch (e) {
        return null;
    }
}

/**
 * @param {string|null|undefined} id
 */
export function setLabcodeCloudProjectId (id) {
    const st = getStorage();
    if (!st) return;
    try {
        if (id) {
            st.setItem(CLOUD_PROJECT_KEY, String(id));
        } else {
            st.removeItem(CLOUD_PROJECT_KEY);
        }
    } catch (e) {
        // ignore
    }
}

export function clearLabcodeCloudProjectId () {
    setLabcodeCloudProjectId(null);
}

/**
 * @returns {string|null}
 */
export function getLabcodeStudentToken () {
    const st = getStorage();
    if (!st) return null;
    try {
        return st.getItem(TOKEN_KEY);
    } catch (e) {
        return null;
    }
}

/**
 * @returns {object|null}
 */
export function getLabcodeStudentProfile () {
    const st = getStorage();
    if (!st) return null;
    try {
        const raw = st.getItem(STUDENT_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch (e) {
        return null;
    }
}

export function hasLabcodeStudentSession () {
    return Boolean(getLabcodeStudentToken());
}

/**
 * @param {string} token
 * @param {object} student
 * @returns {boolean} true se a sessão ficou guardada (necessário para o portão de login abrir o editor)
 */
export function setLabcodeStudentSession (token, student) {
    const st = getStorage();
    if (!st) return false;
    clearStaffKeys(st);
    clearLabcodeCloudProjectId();
    try {
        st.setItem(TOKEN_KEY, token);
        st.setItem(STUDENT_KEY, JSON.stringify(student || {}));
    } catch (e) {
        return false;
    }
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('labcode-student-session-changed'));
    }
    return true;
}

export function clearLabcodeStudentSession () {
    const st = getStorage();
    if (!st) return;
    clearLabcodeCloudProjectId();
    try {
        st.removeItem(TOKEN_KEY);
        st.removeItem(STUDENT_KEY);
    } catch (e) {
        // ignore
    }
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('labcode-student-session-changed'));
    }
}
